import { router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogFooter, DialogTitle, DialogDescription } from "@/components/ui/dialog"

export function DeleteAgentDialog({ open, onOpenChange, agentId, workspaceSlug }) {
  function handleDelete() {
    router.delete(`/${workspaceSlug}/agents/${agentId}`, {
      onFinish: () => onOpenChange(false)
    })
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" onOpenAutoFocus={(e) => e.preventDefault()}>
        <div className="py-4 px-6 gap-0.5">
          <DialogTitle className="text-lg font-medium mb-3">Delete agent</DialogTitle>
          <DialogDescription>
            <p className="mb-4">Are you sure you want to delete this agent?</p>
            <p>This action cannot be undone, and all run and preview data will be deleted.</p>
          </DialogDescription>
        </div>
        <DialogFooter className="justify-between gap-2">
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button variant="destructive" size="sm" onClick={handleDelete}>Delete</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
